import React from "react";

const Chevron = ({className}) => (
  <svg
    className={className}
    fill="currentColor"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
        fill="currentColor"
        clipRule="evenodd"
        fillRule="evenodd"
        d="M13.8788 12.7071C14.2693 12.3165 14.2693 11.6834 13.8788 11.2928L8.00007 5.41417C7.60955 5.02364 7.60955 4.39048 8.00008 3.99995C8.3906 3.60943 9.02376 3.60943 9.41429 3.99995L16.7072 11.2928C17.0977 11.6834 17.0977 12.3165 16.7072 12.7071L9.41429 20C9.02376 20.3905 8.3906 20.3905 8.00008 20C7.60955 19.6094 7.60955 18.9763 8.00008 18.5857L13.8788 12.7071Z"
    />
  </svg>
);

export default Chevron;
